import { mutationFor } from "@visioni/a3s-client-api/app";
import {
  clearAlarmOverrideEndpoint,
  setAlarmOverrideEndpoint,
  setAlarmSilenceEndpoint,
} from "../client-messages/alarms";
import { setNotificationPreferenceCategoryEndpoint } from "../client-messages/notification-preferences";
import { setContactPhoneNumberEndpoint } from "../client-messages/notification-contact-info";

/**
 * React Query mutation factories for the alarm control write-side.
 * Paired with the Phase-1 view model and the Phase-2 `interpret` translator:
 *
 *   view + command → interpret(...) → MutationRequest → {one of these}
 */

export const setAlarmOverrideMutation = mutationFor(setAlarmOverrideEndpoint);
export const clearAlarmOverrideMutation = mutationFor(clearAlarmOverrideEndpoint);
export const setAlarmSilenceMutation = mutationFor(setAlarmSilenceEndpoint);

/**
 * React Query mutation factory for replacing one scope+category's channel
 * preferences. Usage: `setNotificationPreferenceCategoryMutation(apiConfig, {})`.
 */
export const setNotificationPreferenceCategoryMutation = mutationFor(setNotificationPreferenceCategoryEndpoint);

/**
 * React Query mutation factory for replacing (or clearing, with `null`) the
 * calling user's contact phone number. Usage: `setContactPhoneNumberMutation(apiConfig, {})`.
 */
export const setContactPhoneNumberMutation = mutationFor(setContactPhoneNumberEndpoint);
